var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuJiaoshigongchuangSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72168 2.37888C10.8778 1.87314 13.1222 1.87314 15.2783 2.37888C18.4253 3.11715 20.8828 5.57467 21.6211 8.72165C22.1268 10.8777 22.1268 13.1222 21.6211 15.2783C20.8828 18.4253 18.4253 20.8828 15.2783 21.6211C13.1222 22.1268 10.8778 22.1268 8.72168 21.6211C5.5747 20.8828 3.11718 18.4252 2.37891 15.2783C1.87317 13.1222 1.87317 10.8777 2.37891 8.72165C3.11719 5.5747 5.57473 3.11716 8.72168 2.37888ZM4.1836 9.87888C3.89814 11.5167 3.94539 13.1979 4.32618 14.8213C4.89093 17.2289 6.77105 19.109 9.17872 19.6738C9.77955 19.8147 10.3885 19.9083 11 19.958V9.87888H4.1836ZM13 16.1211V19.958C13.6116 19.9083 14.2205 19.8147 14.8213 19.6738C16.7752 19.2155 18.3818 17.8909 19.2197 16.1211H13ZM13 14.1211H19.8164C20.1019 12.4832 20.0546 10.802 19.6738 9.17868C19.1091 6.77102 17.2289 4.8909 14.8213 4.32615L14.4229 4.24021C13.9519 4.14603 13.4768 4.07977 13 4.04099V14.1211ZM11 4.04099C10.3884 4.09055 9.77955 4.18521 9.17872 4.32615C7.22482 4.78447 5.61825 6.10905 4.78028 7.87888H11V4.04099Z",
    fill: "#F5B544"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuJiaoshigongchuangSelected);
export default __webpack_public_path__ + "static/media/menu_jiaoshigongchuang_selected.e747c023a63469c61bdac1bcf7186c86.svg";
export { ForwardRef as ReactComponent };